export type SubRole = "MELEE" | "RANGED";

interface Role {
	name: "TANK" | "HEALING" | "DPS";
	subroles: (SubRole | "")[];
}

const roles: Role[] = [
	{
		name: "TANK",
		subroles: []
	},
	{
		name: "HEALING",
		subroles: []
	},
	{
		name: "DPS",
		subroles: ["", "MELEE", "RANGED"]
	}
];

export default roles;